module.exports = __webpack_public_path__ + "assets/img/INTERIOR4.5cc8d383.png";